import {
  categoriesDataRequest,
  categoriesDataSuccess,
  categoriesDataFailure,
} from '.';
import { AdminService } from '../../services/requests';

const CastingsHelper = {
  getAllCastings: () => async (dispatch) => {
    dispatch(categoriesDataRequest());
    try {
      const response = await AdminService.getAllCategories();
      if (response) {
        dispatch(categoriesDataSuccess(response));
      }
    } catch (err) {
      dispatch(categoriesDataFailure(err));
    }
  },
};

export default CastingsHelper;
